import type { CarDataType, CompareMotorizationType, ModelGradeBodyTypeIdsType } from "../../utils/newCarCompareTypes";

export const NEW_CAR_COMPARE_ADD_CAR = "newCarCompare/addCar" as const;
export const NEW_CAR_COMPARE_REMOVE_CAR = "newCarCompare/removeCar" as const;
export const NEW_CAR_COMPARE_CLEAR_ALL = "newCarCompare/clearAll" as const;
export const NEW_CAR_COMPARE_SET_FINANCE_PRODUCT = "newCarCompare/setFinanceProduct" as const;

export type NewCarCompareAddCarType = {
    type: typeof NEW_CAR_COMPARE_ADD_CAR;
    modelGradeBodyTypeIds: ModelGradeBodyTypeIdsType;
    motorizationIds: CompareMotorizationType | null;
    data: CarDataType | null;
    index: number;
    colourCode: string | null;
};
export type NewCarCompareRemoveCarType = { type: typeof NEW_CAR_COMPARE_REMOVE_CAR; index: number };
export type NewCarCompareClearAllType = { type: typeof NEW_CAR_COMPARE_CLEAR_ALL };
export type NewCarCompareSetFinanceProductType = {
    type: typeof NEW_CAR_COMPARE_SET_FINANCE_PRODUCT;
    financeProduct: string | undefined;
};

// Get the car with the modelGradeBodyTypeIds, by default the first engine is selected, but this can be
// overruled by also passing along the motorizationIds (wheeldrive, transmission and engine Id).
export const compareAddCar = (
    modelGradeBodyTypeIds: ModelGradeBodyTypeIdsType,
    motorizationIds: CompareMotorizationType | null,
    index: number,
    colourCode: string | null = null,
): NewCarCompareAddCarType => ({
    type: NEW_CAR_COMPARE_ADD_CAR,
    modelGradeBodyTypeIds,
    motorizationIds,
    index,
    data: null,
    colourCode,
});
export const compareRemoveCar = (index: number): NewCarCompareRemoveCarType => ({
    type: NEW_CAR_COMPARE_REMOVE_CAR,
    index,
});
export const compareClearAll = (): NewCarCompareClearAllType => ({ type: NEW_CAR_COMPARE_CLEAR_ALL });

export const compareSetFinanceProduct = (financeProduct: string | undefined): NewCarCompareSetFinanceProductType => ({
    type: NEW_CAR_COMPARE_SET_FINANCE_PRODUCT,
    financeProduct,
});

export type NewCarCompareExternalDataActionsType =
    | NewCarCompareAddCarType
    | NewCarCompareRemoveCarType
    | NewCarCompareClearAllType
    | NewCarCompareSetFinanceProductType;
